<template>
  <b-container fluid>
    <b-row class="select-one-preference-input">
      <b-col cols="12" class="d-flex p-0">
        <b-form-radio-group
          stacked
          :options="options"
          :checked="checkedValue"
          @change="onChangeHandler"
          class="v3_control_radio_group"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import SubFormValidationMethodsMixin from '@/mixins/SubFormValidationMethodsMixin';

export default {
  name: 'SelectOnePreferenceInput',
  mixins: [validationMixin, SubFormValidationMethodsMixin],
  props: {
    jobQuestion: {
      required: true,
    },
    studyQuestion: Object,
  },
  validations: {
    selected: {},
  },
  computed: {
    checkedValue: function () {
      const jQv = this.jobQuestion.jobQuestionVariables.find(
        (jQv) => jQv.jobProfileQuestionResponses[0].value === 1
      );
      return jQv ? jQv.id : null;
    },
    options: function () {
      return this.jobQuestion.jobQuestionVariables.map(
        ({ id, input_label }) => ({
          value: id,
          text: input_label,
        })
      );
    },
  },
  methods: {
    onChangeHandler: function (checkedValue) {
      this.$emit('set-preference', checkedValue);
      this.$v.selected.$touch();
    },
  },
};
</script>

<style lang="scss">
.v3_control_checkbox.custom-control > .custom-control-label{
  font-size: .875rem !important;
}
</style>
